<template>
	<div class="text" v-html="data.text"></div>
</template>

<script>
    // 引入mixins
    import mixins_config from "@/mixins/config.js";
    export default {
        name: "TextComponent",
        mixins: [mixins_config],
        components: {},
        props: {
            data: {
                type: Object,
                required: true,
            },
        },
    }
</script>

<style scoped>

</style>